import { render, staticRenderFns } from "./punishment.vue?vue&type=template&id=8a028e8a&scoped=true&"
import script from "./punishment.vue?vue&type=script&lang=js&"
export * from "./punishment.vue?vue&type=script&lang=js&"
import style0 from "./punishment.vue?vue&type=style&index=0&id=8a028e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a028e8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a028e8a')) {
      api.createRecord('8a028e8a', component.options)
    } else {
      api.reload('8a028e8a', component.options)
    }
    module.hot.accept("./punishment.vue?vue&type=template&id=8a028e8a&scoped=true&", function () {
      api.rerender('8a028e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/punishment.vue"
export default component.exports